import OnboardingWelcomePage from './OnboardingWelcomePage'

export default OnboardingWelcomePage
